import { render, staticRenderFns } from "./ButtonWithBadgeWrapper.vue?vue&type=template&id=5fb51c77&scoped=true&"
import script from "./ButtonWithBadgeWrapper.vue?vue&type=script&lang=js&"
export * from "./ButtonWithBadgeWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithBadgeWrapper.vue?vue&type=style&index=0&id=5fb51c77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb51c77",
  null
  
)

export default component.exports